import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const purgeReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_REF_DATA_PURGE_SETUPS:
            return {
                ...state,
                refDataPurgeProcess: action.payload,
            };
        case actionTypes.GET_REF_DATA_PURGE_CONFIGS:
            return {
                ...state,
                refDataPurgeConfigs: action.payload,
            };
        default:
            return state;
    }
};

export default purgeReducer;
